import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'app类型',
            prop:'type',
            align:'center',
            headerAlign:'center',
            width: 120,
            tooltip:true,
			render: (h, params) => {
			    let text = ""
			    let color = ""
			    let list = store.state.conText.appType
			    for(var i in list){
			       if(params.row.type*1 == list[i].val*1){
			          text = list[i].title
			       }
			    }
			    return h('span',{style:{color:""}},text)
			}
        },
		{
		    label:'版本号',
		    prop:'releaseVersion',
		    align:'left',
		    headerAlign:'left',
			tooltip:true
		},
        {
            label:'下载次数',
            prop:'downloadCount',
            align:'center',
            headerAlign:'center',
            width:100,
        },
		{
		    label:'备注信息',
		    prop:'remark',
		    tooltip:true,
            render: (h, params) => {
			    return h('span',{style:{color:""}},!params.row.remark ? "--":params.row.remark)
			}
		},
        {
		    label:'上线时间',
		    prop:'onlineTime',
		    tooltip:true,
            width:200,
		},
		{
		    label:'状态',
		    prop:'status',
		    align:'center',
		    headerAlign:'center',
            width:80,
            render: (h, params) => {
			    return h('span',{style:{color:""}},params.row.status ? "启用":"禁用")
			}
		},
        {
            label:'操作',
            width:90,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                let eidtBtn = (h)=>{
                    return h('el-link',{
                        props:{
                            type:'primary',
                            underline:false
                        },
                        style:{
                            color:"#3AE2CE"
                        },
                        on:{
                            click:()=>{vm.eidtBtn(params.row)}
                        }
                    },'编辑')
                }
                let btnArr = [];
                btnArr.push(eidtBtn(h));              
                return h('span',{},btnArr)
            }
        }
    ]
}